import Env from '../base/env'
import Channels from '../base/channels'
import Draggable from 'gsap/Draggable'
import ThrowPropsPlugin from '../vendor/gsap-bonus/ThrowPropsPlugin';
import raf from 'raf'
import Waypoints from '../vendor/waypoints'


export default class Timeline
{
    constructor(view)
    {
        this.view = view
        this.$collection = this.view.querySelector('.jsCollection')
        this.$items = this.view.querySelectorAll('.jsItem')
        this.$cursor = this.view.querySelector('.jsCursor')
        this.$velocityItems = this.view.querySelectorAll('.jsVelocity')
        this.$progress = this.view.querySelector('.jsProgress')
        this.$lineProgress = this.view.querySelector('.jsLine')
        this.$zoom = Env.$zoomView
        this.$zoomOverlay = Env.$zoomOverlay
        // Popin
        this.$popin = Env.$popinView
        this.$popinReceptor = this.$popin.querySelector('.jsReceptor')
        this.$popinClose = this.$popin.querySelector('.jsClose')
        // Modes
        this.MOUSEOVER_MODE = false;
        this.MOUSEMOVE_FOLLOW_MODE = false
        this.SCROLL_AUTO_MODE = true
        // Objects
        this.IS_PAUSING = false
        this.IS_DRAGGING = false
        this.IS_DRAGGING_INDICATOR = false
        this.IS_CENTERING = false
        this.IS_HOVERED_INDICATOR = false;
        this.IS_TOUCH = 'ontouchstart' in window
        this.TOTAL = this.$items.length - 1
        this.FORCE_PROGRESS_WIDTH = true
        this.bounds = {}
        this.instanceDrag = false
        this.instanceDragIndicator = false
        this.raf = undefined
        this.MULTIPLY_DISTANCE = (this.MOUSEOVER_MODE == true)?5:0
        this.RATE_EQ = 15
        this.FOLLOW_INERTIA = 1.5
        this.MOUSEX_DIRECTION = 0
        this.POPIN_ENABLED = false
        this.SPEED_AUTOSCROLL = .8
        this.minX = (Env.mobileCSS == true)?30:130
        this.waypointAutoscroll = false
        // States
        this.mouseCoord = { x : 0 , y : 0 }
        this.newMouseCoord = { x : 0 , y : 0 }
        this.mouseDir = { x : 0 , y : 0 }
        this.distance = { x : 0 , y : 0 }
        this.scrollAuto = { x : 0 , y : 0 }
        this.lineProgressWidth = this.$lineProgress.getBoundingClientRect().width
        this.wheel = { x : 0 }
        this.newWheel = { x : 0 }
        this.ratioScroll = 0
        this.timeoutPopinClean = false
        this.progression = 0
        this.progressionOffsetX = 0
        this.progressForceWidth = 40
        this.dragDistance = { start : 0 , end : 0 , val : 0 }
        // Vars Cursor
        this.currentPositionCursor = { x : -500 , y : -500 }
        this.newPositionCursor = { x : 0 , y : 0 }
        this.inertia = 4
        // Fns
        this.funcResize = this.resize.bind(this)
    }

    center(item)
    {
        const viewport = Env.framework.toolbox.getViewport()
        const coordinates = item.querySelector('.hover').getBoundingClientRect()
        const middleX = (viewport.width / 2 ) - (coordinates.width / 2)
        const middleY = (viewport.height / 2 ) - (coordinates.height / 2)
        let getScrollX = this.$collection._gsTransform.x
        let getScrollY = this.$collection._gsTransform.y
        let positionX = (coordinates.x * -1) + getScrollX
        let positionY = (coordinates.y * -1) + getScrollY

        let newPositionX = positionX + middleX
        if(newPositionX > this.bounds.minX) {
            newPositionX = this.bounds.minX
        } else if(newPositionX < this.bounds.maxX) {
            newPositionX = this.bounds.maxX
        }

        // TweenLite.to(this.$collection , .7 ,  { x : newPositionX , y : positionY + middleY , ease : Power4.easeOut ,
        // TweenLite.to(this.$collection , .7 ,  { x : newPositionX  , ease : Power4.easeOut ,
        //     onStart : ()=>{
        //         this.IS_CENTERING = true
        //     },
        //     onComplete: ()=>{
        //         this.IS_CENTERING = false
        //     }
        // })
        setTimeout(() => {
            TweenLite.set(this.$collection , { x : newPositionX })
        }, 600);
    }

    configure()
    {
        const viewport = Env.framework.toolbox.getViewport()
        const $lastItem = this.$items[this.TOTAL]
        const coordinates = $lastItem.getBoundingClientRect()
        let lastPoint = coordinates.left + coordinates.width
        let lastMarginRight = (Env.mobileCSS)?30:0
        lastPoint += lastMarginRight + this.minX
        $lastItem.classList.add('is--last')

        this.$collection.style.width = `${lastPoint}px`
        this.bounds = { minX : this.minX , maxX : (lastPoint - viewport.width) * -1 , minY : 0, maxY : 0 }
        TweenLite.set(this.$collection , {  x : this.minX })

        // Size Scroll Indicator
        const distanceToDo = lastPoint - viewport.width
        const distancePercentage = distanceToDo / lastPoint
        const distanceRatio = 1 - distancePercentage
        const progressParentSize = this.$progress.parentElement.getBoundingClientRect().width
        let progressWidth;
        if(this.FORCE_PROGRESS_WIDTH == true) {
            progressWidth = this.progressForceWidth
        } else {
            progressWidth = progressParentSize * distanceRatio
        }
        this.$progress.style.width = `${progressWidth}px`
        this.progressionOffsetX = progressParentSize - progressWidth
    }

    destroy()
    {
        Channels.removeListener('window::smartresize',this.funcResize)
        raf.cancel(this.raf)
        this.popinClose()

    }

    draggable()
    {
        let settings = {}
        if(Env.mobileCSS == true) {
            settings.lock = true
            settings.type = "x"
            settings.dragResistance = .01
            settings.maxDuration = 1
            settings.minDuration = .1
        } else {
            settings.lock = false
            settings.type = "x"
            settings.dragResistance = .5
            settings.maxDuration = 1
            settings.minDuration = .5
        }
        this.configure()

        if(Env.mobileCSS == true) {
            return false
        }
        // Drag
        this.instanceDrag = Draggable.create(
            this.$collection,
            {
                cursor: 'grab',
                type:settings.type,
                edgeResistance:.99,
                dragResistance : settings.dragResistance,
                force3D : false,
                lockAxis : settings.lock,
                throwProps:true,
                minDuration:settings.minDuration,
                maxDuration:settings.maxDuration,
                throwResistance: 3000,
                dragClickables : true,
                bounds : this.bounds,
                onDragStart:(e)=>{
                    this.IS_DRAGGING = true
                    if(this.scrollAuto.x == 0) {
                        this.IS_PAUSING = false
                        this.startAutoscroll()
                    }
                    this.$collection.classList.add('is--dragging')
                    this.dragDistance.start = e.x

                },
                onDrag:(e)=>{

                    this.currentPositionCursor.x = e.clientX
                    this.currentPositionCursor.y = e.clientY
                },
                onDragEnd:(e)=>{
                    this.$collection.classList.remove('is--dragging')
                    this.dragDistance.end = e.x
                    this.dragDistance.val = this.dragDistance.end - this.dragDistance.start
                },
                onThrowComplete:()=>{
                    this.IS_DRAGGING = false
                }
            }
        )
        // Drag Indicator
        this.instanceDragIndicator = Draggable.create(
            this.$progress,
            {
                cursor: 'grab',
                type:settings.type,
                edgeResistance:1,
                dragResistance : 0.1,
                force3D : true,
                lockAxis : settings.lock,
                throwProps:true,
                minDuration:.8,
                maxDuration:1.4,
                throwResistance: 3000,
                dragClickables : true,
                bounds : { minX : 0, maxX : this.progressionOffsetX },
                onDragStart:()=>{
                    this.IS_DRAGGING_INDICATOR = true
                    this.$collection.classList.add('disabled--dragging')
                    this.$progress.classList.add('is--dragging')
                },
                onDragEnd:()=>{
                    this.$cursor.classList.remove('is--hovered')
                    this.$progress.classList.remove('is--dragging')
                },
                onThrowComplete:()=>{
                    this.IS_DRAGGING_INDICATOR = false
                    this.$collection.classList.remove('disabled--dragging')
                }
            }
        )
    }

    events()
    {
        Channels.on('window::smartresize',this.funcResize)

        if(!this.IS_TOUCH) {
            this.wheelOn();
        }

        this.view.addEventListener('mousemove',(e)=>
        {
            this.currentPositionCursor.x = e.clientX
            this.currentPositionCursor.y = e.clientY

            const
            viewport = Env.framework.toolbox.getViewport()
            ,contextWidth = viewport.width / 2
            ,contextHeight = viewport.height / 2

            this.mouseCoord.x = 1 - (e.clientX / contextWidth)
            this.mouseCoord.y = 1 - (e.clientY / contextHeight)
            this.mouseDir.x = 1 - (e.clientX / contextWidth)
            this.mouseDir.y = 1 - (e.clientY / contextHeight)

        })

        this.view.addEventListener('mouseenter',()=>{
            if(this.$cursor.classList.contains('is--active') === false) {
                this.$cursor.classList.add('is--active')
            }

        })
        this.view.addEventListener('mouseleave',()=>{
            if(this.$cursor.classList.contains('is--active') === true) {
                this.$cursor.classList.remove('is--active')
            }
        })

        this.$lineProgress.addEventListener('click',(event)=>{

            this.IS_DRAGGING_INDICATOR = true
            const ratio = event.offsetX / this.lineProgressWidth
            const posX = (this.lineProgressWidth - this.progressForceWidth) * ratio

            TweenLite.to(this.$progress , .4 , { x : posX , ease : Cubic.easeOut , onComplete : ()=>{
                    this.IS_DRAGGING_INDICATOR = false
                }
            })

        })

        this.$progress.addEventListener('mouseenter',()=>{
            this.IS_HOVERED_INDICATOR = true
        })
        this.$progress.addEventListener('mouseleave',()=>{
            this.IS_HOVERED_INDICATOR = false
        })

        for(let i = 0; i < this.$items.length; i++) {
            const $item = this.$items[i]
            $item.addEventListener('click',()=>{
                if(this.POPIN_ENABLED == false) {
                    $item.classList.add('is--active')
                    this.$collection.classList.add('item--isOpened')
                    setTimeout(() => {
                        this.center($item)
                        this.popinOpen($item)
                    }, 200);
                }
                return false
            })
            $item.addEventListener('mouseenter',()=>{
                this.$cursor.querySelector('.text').innerHTML = 'open';
            })
            $item.addEventListener('mouseleave',()=>{
                this.$cursor.querySelector('.text').innerHTML = 'drag';
            })
        }

        this.$popinClose.addEventListener('click',()=>{
            if(this.POPIN_ENABLED == true) {
                this.popinClose()
            }
        })
    }

    popinClose()
    {

        this.$popin.classList.remove('is--active')
        Env.$html.classList.remove('popin--isOpened')
        TweenLite.to(this.$zoomOverlay , .4 , { opacity : 0 , ease : Cubic.easeOut })
        TweenLite.to(this.$zoom , .5 , { opacity : 0 , ease : Cubic.easeOut , onComplete : ()=>{
            this.$zoom.removeAttribute('style')
            this.$zoom.querySelector('.bg').removeAttribute('style')

        }
    })
        this.POPIN_ENABLED = false

        this.timeoutPopinClean = setTimeout(() => {
            this.$popinReceptor.innerHTML = ''
            this.startAutoscroll()
        }, 500);
    }

    popinOpen($item)
    {
        clearTimeout(this.timeoutPopinClean)
        const html = $item.querySelector('.jsContent').innerHTML
        this.$popinReceptor.innerHTML = html

        if(Env.mobileCSS == true) {
            this.$popin.classList.add('is--active')
            Env.$html.classList.add('popin--isOpened')
        } else {
            const coordinates = $item.getBoundingClientRect()
            const viewport = Env.framework.toolbox.getViewport()
            const getBg = this.$popinReceptor.querySelector('.bg').getAttribute('style')
            this.$zoom.querySelector('.bg').setAttribute('style',getBg)
            this.$zoom.style.width = `${coordinates.width}px`
            this.$zoom.style.height = `${coordinates.height}px`
            this.$zoom.style.left = `${coordinates.left}px`
            this.$zoom.style.top = `${coordinates.top}px`

            Env.$html.classList.add('popin--isOpened')
            TweenLite.fromTo(this.$zoomOverlay , .4 , { opacity : 0 } , { opacity : 1 , ease : Cubic.easeOut })
            TweenLite.to(this.$zoom , .5 , { height : viewport.height - 40 , width : (viewport.width / 2) - 10 , left : 20 , top : 20 , ease : Cubic.easeInOut , onStart : ()=>{
                    setTimeout(() => {
                        this.$popin.classList.add('is--active')
                    }, 250);
                }
            })
        }


        this.POPIN_ENABLED = true
        this.stopAutoscroll()
    }

    parallax()
    {
        const viewport = Env.framework.toolbox.getViewport()
        const scroll = this.ratioScroll

        for(let i = 0; i < this.$velocityItems.length; i++) {
            const $item = this.$velocityItems[i]
            const getPosX = $item.getAttribute('data-velocity') * 1
            const getCurrentX = (typeof $item._gsTransform != "undefined")?$item._gsTransform.x:0
            const ratio = ((($item.getBoundingClientRect().left - getCurrentX) + ($item.getBoundingClientRect().width / 2)) / (viewport.width / 2) - 1)
            const newPosX = ratio * getPosX

            TweenLite.set($item , { x : newPosX })

        }
    }

    pauseAutoscroll()
    {
        if(Env.mobileCSS == false) {
            TweenLite.to(this.scrollAuto , 2 , { x : 0 , y : 0 , ease : Power4.easeInOut })
            this.IS_PAUSING = true
            this.dragDistance.val = 0
        }

    }

    startAutoscroll()
    {
        if(Env.mobileCSS == false) {
            this.IS_PAUSING = false
            TweenLite.to(this.scrollAuto , 2 , { x : this.SPEED_AUTOSCROLL * -1 , y : this.SPEED_AUTOSCROLL * -1 , ease : Power4.easeInOut })
            this.MOUSEX_DIRECTION = 1
        }
    }

    stopAutoscroll()
    {
        if(Env.mobileCSS == false) {
            this.IS_PAUSING = true
            this.dragDistance.val = 0
            TweenLite.set(this.scrollAuto , { x : 0 , y : 0 })
        }
    }

    watcher()
    {
        this.raf = raf(()=>{
            this.watcher()
        })

        // console.log(this.IS_DRAGGING_INDICATOR);

        if(this.SCROLL_AUTO_MODE == true && Env.mobileCSS == false && this.IS_PAUSING == false) {
            this.dragDistance.val += (-.1  - this.dragDistance.val) / 2
        }

        if(Env.mobileCSS == false) {

            let getPosition;

            if(this.IS_DRAGGING_INDICATOR == true) {
                getPosition = this.$progress._gsTransform
                const ratioIndicator = getPosition.x / this.progressionOffsetX
                const distanceToDo = this.bounds.maxX - this.bounds.minX
                const newPositionXWithIndicator = (ratioIndicator * distanceToDo) + this.minX

                TweenLite.set(this.$collection , { x  :  newPositionXWithIndicator  })

            } else {
                getPosition = this.$collection._gsTransform

                // Detect direction move
                if(this.newMouseCoord.x >= this.mouseDir.x) {
                    this.MOUSEX_DIRECTION = 1
                } else {
                    this.MOUSEX_DIRECTION = -1
                }

                // Limit Left / Right
                if(this.MOUSEMOVE_FOLLOW_MODE == true) {
                    if((getPosition.x > this.bounds.minX && this.MOUSEX_DIRECTION == -1) || (getPosition.x < this.bounds.maxX && this.MOUSEX_DIRECTION == 1)) {
                        this.mouseCoord.x = 0
                    }
                }

                this.newMouseCoord.x += (this.mouseCoord.x - this.newMouseCoord.x) / this.RATE_EQ
                this.newMouseCoord.y += (this.mouseCoord.y - this.newMouseCoord.y) / this.RATE_EQ

                if((getPosition.x > this.bounds.minX && this.MOUSEX_DIRECTION == -1) || (getPosition.x < this.bounds.maxX && this.MOUSEX_DIRECTION == 1))
                {
                    this.newWheel.x = 0
                } else {
                    this.newWheel.x += (this.wheel.x - this.newWheel.x) / 2
                }



                if(this.IS_DRAGGING == false && this.IS_CENTERING == false) {
                    let distanceX,distanceY;
                    if(this.MOUSEMOVE_FOLLOW_MODE == true) {
                        distanceX = this.newMouseCoord.x * this.FOLLOW_INERTIA
                        distanceY = this.newMouseCoord.y * this.FOLLOW_INERTIA
                    } else {
                        distanceX = (this.mouseCoord.x - this.newMouseCoord.x) * this.MULTIPLY_DISTANCE
                        distanceY = (this.mouseCoord.y - this.newMouseCoord.y) * this.MULTIPLY_DISTANCE
                    }
                    let newXPosition,newYPosition
                    if(this.MOUSEOVER_MODE == true || this.MOUSEMOVE_FOLLOW_MODE == true) {
                        newXPosition = getPosition.x + distanceX
                        newYPosition = getPosition.y + distanceY
                        TweenLite.set(this.$collection , { x  :  newXPosition  })
                    }
                    if(this.SCROLL_AUTO_MODE == true) {


                        if((getPosition.x < this.bounds.maxX)) {
                            this.stopAutoscroll()
                        } else {
                            newXPosition = getPosition.x + this.scrollAuto.x + this.newWheel.x
                            newYPosition = getPosition.y + this.scrollAuto.y
                            TweenLite.set(this.$collection , { x  :  newXPosition + this.dragDistance.val  })

                        }
                    }
                }
            }

            this.newPositionCursor.x += (this.currentPositionCursor.x - this.newPositionCursor.x) / this.inertia
            this.newPositionCursor.y += (this.currentPositionCursor.y - this.newPositionCursor.y) / this.inertia
            TweenLite.set(this.$cursor , { x : this.newPositionCursor.x , y : this.newPositionCursor.y })

            this.parallax()

            // console.log(this.progression);

            // Indicator Position
            this.ratioScroll = this.$collection._gsTransform.x / this.bounds.maxX
            this.progression = (this.$collection._gsTransform.x - this.bounds.minX) / (this.bounds.maxX - this.bounds.minX)
            if(this.progression < 0) this.progression = 0
            if(this.progression > 1) this.progression = 1
            if(this.IS_DRAGGING_INDICATOR === false) {
                TweenLite.set(this.$progress , { x : this.progression * this.progressionOffsetX})
            }
            if(this.IS_HOVERED_INDICATOR == false && this.IS_DRAGGING_INDICATOR == false) {
                this.$cursor.classList.remove('is--hovered')
                Env.$html.classList.remove('cursor--isDragging')
            } else {
                this.$cursor.classList.add('is--hovered')
                Env.$html.classList.add('cursor--isDragging')
            }
        }
    }

    resize()
    {
        if(Env.mobileCSS == false) {
            this.instanceDrag[0].kill()
            this.instanceDrag = false
            TweenLite.set(this.$collection , { clearProps : 'all' })
            for(let i = 0; i <= this.TOTAL; i++) {
                const $item = this.$items[i]
                TweenLite.set($item , { clearProps : 'all' })
            }
            TweenLite.set(this.$collection , { x : 0 , width : 99999 })
            this.bounds = {}
            if(typeof this.waypointAutoscroll != 'undefined') {
                this.waypointAutoscroll.destroy()
            }
            this.draggable()
            this.setWaypoint()
        }
    }

    setup()
    {
        this.draggable()
        this.events()
        if(Env.mobileCSS == false) {
            this.setWaypoint()
        }
        this.watcher()
    }

    setWaypoint()
    {
        const viewport = Env.framework.toolbox.getViewport()
        this.waypointAutoscroll = new Waypoint({
            element: this.view.parentNode,
            handler: (direction)=> {
                if(direction === 'down') {
                    this.pauseAutoscroll()
                } else {
                    this.startAutoscroll()
                }
            },
            offset: -100
        });
    }

    wheelOn()
    {
        const wheel = (e)=>{
            let delta
            if(typeof e.wheelDelta != "undefined") {
                delta = e.wheelDelta
            } else {
                delta = e.deltaY
            }

            this.wheelTask(e);
            if(e.deltaX != 0) {
                e.preventDefault()
                e.stopPropagation()
            }

        }
        this.view.addEventListener('wheel', wheel,true); // for Firefox
        this.view.addEventListener('mousewheel', wheel,true); // for everyone else
    }

    wheelTask(_e)
    {
        this.newWheel.x = (typeof _e.wheelDeltaX != "undefined")?_e.wheelDeltaX:_e.deltaX * -100
        const getPosition = this.$collection._gsTransform

        if(getPosition.x >= this.bounds.minX) {
            this.newWheel.x = 0
        } else if(getPosition.x <= this.bounds.maxX) {
            const distanceToRight = getPosition.x + this.newWheel.x
            if(distanceToRight >= this.bounds.maxX) {
                TweenLite.set(this.$collection , { x : '+='+this.newWheel.x })
                this.startAutoscroll()
            }

        }
    };
}


// WEBPACK FOOTER //
// ./resources/js/components/Timeline.js